import ManagerVoucher from './ManagerVoucher.container';

export default ManagerVoucher;
